import React from 'react';
import { useNavigate } from 'react-router-dom';
import './PrivacyPolicy.css';

const PrivacyPolicy: React.FC = () => {
  const navigate = useNavigate();

  const handleBackClick = () => {
    navigate('/');
  };

  return (
    <div className="privacy-policy">
      <button onClick={handleBackClick} className="back-link">
        ← Вернуться на главную
      </button>
      
      <h1>Политика конфиденциальности и обработки персональных данных</h1>
      
      <h2>1. Общие положения</h2>
      <p><strong>1.1.</strong> Настоящая Политика конфиденциальности и обработки персональных данных (далее — «Политика») разработана в соответствии с Федеральным законом от 27.07.2006 г. № 152-ФЗ «О персональных данных» и определяет порядок работы с персональными данными пользователей сервиса Dissai (далее – «Сервис»).</p>
      
      <p><strong>1.2.</strong> Оператором персональных данных является Общество с ограниченной ответственностью «ДИСАЙ» (ИНН: 0500031568, ОГРН: 1250500006283), расположенное по адресу: 367000, Респ. Дагестан, г. Махачкала, ул. Абубакарова, д. 115, каб. 2, помещ. 2 (далее – «Оператор», «мы»).</p>
      
      <p><strong>1.3.</strong> Настоящая Политика является неотъемлемой частью Публичной оферты. Используя Сервис, Пользователь подтверждает свое полное согласие с условиями настоящей Политики. Согласие выражается путем проставления отметки (галочки) в соответствующем поле при регистрации в Сервисе.</p>
      
      <h2>2. Объем и категории обрабатываемых данных</h2>
      <p>Мы обрабатываем следующие категории данных:</p>
      
      <div className="data-category">
        <h4>2.1. Данные, предоставляемые при регистрации:</h4>
        <ul className="data-list">
          <li>Адрес электронной почты (e-mail).</li>
        </ul>
      </div>
      
      <div className="data-category">
        <h4>2.2. Данные, предоставляемые Пользователем добровольно для получения дополнительных услуг (например, при отправке заявки на обратную связь):</h4>
        <ul className="data-list">
          <li>Имя и фамилия.</li>
          <li>Номер телефона.</li>
        </ul>
      </div>
      
      <div className="data-category">
        <h4>2.3. Данные, которые мы получаем автоматически при использовании Сервиса (Технические данные):</h4>
        <ul className="data-list">
          <li>IP-адрес, тип браузера и устройства, файлы cookie.</li>
        </ul>
      </div>
      
      <div className="data-category">
        <h4>2.4. Данные, которые обрабатываются в процессе оказания услуг (Контентные данные):</h4>
        <ul className="data-list">
          <li>Созданные контент-планы, история запросов к ИИ, загруженные материалы.</li>
        </ul>
      </div>
      
      <div className="data-category">
        <h4>2.5. Данные платежных систем:</h4>
        <ul className="data-list">
          <li>Мы не собираем и не храним данные ваших банковских карт. Эта информация обрабатывается на стороне сертифицированных платежных систем.</li>
        </ul>
      </div>
      
      <h2>3. Цели и правовые основания обработки данных</h2>
      
      <div className="purpose-block">
        <h4>3.1. Для данных, полученных при регистрации (e-mail):</h4>
        <p><strong>Цель:</strong> Создание и управление аккаунтом, исполнение договора (Оферты), отправка системных уведомлений, обработка платежей.</p>
        <p><strong>Основание:</strong> Исполнение договора, стороной которого является Пользователь (п. 5 ч. 1 ст. 6 ФЗ-152).</p>
      </div>
      
      <div className="purpose-block">
        <h4>3.2. Для данных, полученных добровольно (имя, телефон):</h4>
        <p><strong>Цель:</strong> Обработка заявки Пользователя и обратная связь с ним.</p>
        <p><strong>Основание:</strong> Согласие субъекта персональных данных (п. 1 ч. 1 ст. 6 ФЗ-152), полученное в момент отправки соответствующей формы.</p>
      </div>
      
      <div className="purpose-block">
        <h4>3.3. Для технических и контентных данных:</h4>
        <p><strong>Цель:</strong> Обеспечение работы и безопасности Сервиса, улучшение качества услуг.</p>
        <p><strong>Основание:</strong> Законный интерес Оператора (п. 7 ч. 1 ст. 6 ФЗ-152).</p>
      </div>
      
      <h2>4. Хранение и передача данных</h2>
      <p><strong>4.1. Локализация:</strong> Хранение персональных данных Пользователей осуществляется в базах данных, находящихся <strong>на территории Российской Федерации</strong>.</p>
      
      <p><strong>4.2. Передача третьим лицам:</strong> Мы не передаем ваши персональные данные третьим лицам, за исключением случаев:</p>
      <ul>
        <li>Передача платежным системам для обработки платежей.</li>
        <li>Передача аналитическим сервисам (например, Яндекс.Метрика) в обезличенном виде для улучшения работы Сервиса.</li>
        <li>По законному требованию государственных органов.</li>
      </ul>
      
      <p><strong>4.3. Трансграничная передача:</strong> Мы можем осуществлять трансграничную передачу данных (например, при использовании зарубежных сервисов аналитики). Такая передача происходит только при условии обеспечения адекватной защиты прав субъектов данных и в строгом соответствии с законодательством РФ.</p>
      
      <h2>5. Сроки хранения данных</h2>
      <ul>
        <li><strong>5.1.</strong> Данные аккаунта (e-mail) хранятся до тех пор, пока существует аккаунт Пользователя.</li>
        <li><strong>5.2.</strong> Данные, предоставленные добровольно (имя, телефон), хранятся до момента достижения цели их обработки (например, до завершения консультации по заявке).</li>
        <li><strong>5.3.</strong> Технические логи хранятся не более 12 месяцев.</li>
      </ul>
      
      <h2>6. Права субъекта персональных данных</h2>
      <div className="rights-list">
        <h4>Пользователь имеет право:</h4>
        <ul>
          <li>Получать информацию, касающуюся обработки его данных.</li>
          <li>Требовать уточнения, блокирования или уничтожения своих данных.</li>
          <li><strong>Отзывать свое согласие на обработку персональных данных.</strong></li>
          <li>Получать копию своих данных.</li>
        </ul>
      </div>
      
      <p>Для реализации своих прав Пользователь может направить запрос на электронный адрес: <strong>privacy@dissai.ru</strong>. Отзыв согласия не влияет на законность обработки, осуществленной до его отзыва.</p>
      
      <h2>7. Безопасность данных</h2>
      <p>Мы принимаем необходимые правовые, организационные и технические меры для защиты персональных данных от неправомерного доступа, в том числе: шифрование, контроль доступа, регулярное обновление систем безопасности.</p>
      
      <h2>8. Использование файлов cookie</h2>
      <p>Мы используем файлы cookie для обеспечения функционирования и анализа использования Сервиса. При первом посещении сайта мы запрашиваем ваше согласие на использование cookie через специальный баннер.</p>
      
      <h2>9. Изменения в Политике</h2>
      <p>Мы можем обновлять настоящую Политику. О существенных изменениях мы уведомим вас по электронной почте или через уведомление в Сервисе.</p>
      
      <h2>10. Контактная информация</h2>
      <div className="contact-info">
        <p>По всем вопросам, связанным с обработкой ваших персональных данных, вы можете обратиться к нам:</p>
        <p><strong>ООО «ДИСАЙ»</strong></p>
        <p><strong>ОГРН:</strong> 1250500006283</p>
        <p><strong>ИНН:</strong> 0500031568</p>
        <p><strong>Адрес:</strong> 367000, Респ. Дагестан, г. Махачкала, ул. Абубакарова, д. 115, каб. 2, помещ. 2</p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;